import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({
  providedIn: "root",
})
export class SnackBarService {
  constructor(private readonly snackBar: MatSnackBar) {}

  openSnackBar(message: string, action: string, type: string, duration = 5000) {
    let panelClass: string[];

    switch (type) {
      case "success":
        panelClass = ["green-snackbar", "login-snackbar"];
        break;
      case "error":
        panelClass = ["red-snackbar", "login-snackbar"];
        break;
      case "info":
        panelClass = ["blue-snackbar", "login-snackbar"];
        break;
      case "warning":
        panelClass = ["yellow-snackbar", "login-snackbar"];
        break;
      default:
        panelClass = [];
        break;
    }

    this.snackBar.open(message, action, {
      duration: duration,
      verticalPosition: "top",
      horizontalPosition: "center",
      panelClass: panelClass,
      politeness: "assertive",
    });
  }
}
